<template>
    <div> 
        <div v-if="vs.mdAndUp" class="">
            <mbs-sale-actions-modes
                :click_mode="click_mode" 
                @on_item_action="ITEM_ACTION" 
                @on_add_item="ADD_ITEM" 
            />
        </div>
        <!-- //DIALOGS -->
        <div v-else>
            <!-- ACTION MENU -->
            <v-dialog
                v-model="dialog_action_menu"
                scrollable   
                :persistent="false" :overlay="false"
                max-width="950px"
                transition="dialog-transition" >
                <v-card rounded="lg"  > 
                    <mbs-sale-actions-modes
                        :click_mode="click_mode"
                        @on_item_action="ITEM_ACTION" 
                        @on_add_item="ADD_ITEM" 
                    />
                </v-card> 
            </v-dialog>  
        </div>
    </div>
</template> 
<script> 

    import DATA from "../../../plugins/DATA";
    import {mapState} from "vuex"  
    const PAGE_NAME = "SALE-ACTIONS"

    export default {
        props:['height',"click_mode"],
        data(){
            return{
                show:false,   
                dialog_action_menu:false,   
                 
            }
        },
        created(){ 
            try { 
                this.MBS.events.$on('ON_ITEM_ACTION', this.ON_ITEM_ACTION); 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted(){  
        },
        computed:{
            vs(){
                let vs = this.$vuetify.breakpoint 
                console.log(vs,'vs............');
                
                return vs
            }, 
            vs_width(){
                let vs = this.vs
                if(!vs){return null}
                return vs.width
            },
            vsh(){
                return this.vs.height
            },
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                SELECTED_COMPANY: state=> state.items['SELECTED_COMPANY'],
                K_CONNECTOR: state=> state.items['K_CONNECTOR'],
            }),
            ...mapState({
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
                CompanyQuickActions: state=> state.items[(DATA.ITEMS.COMPANY_QUICK_ACTIONS.values).toUpperCase()], 
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                ItemDepartments: state=> state.items[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()],

                
            }), 

             
        },
        methods:{ 
            ITEM_ACTION(action,item,option){
                this.$emit("on_item_action",action,item,option)
            },
            ADD_ITEM(item_key, item_code){
                this.$emit("on_add_item",item_key, item_code)
            },
            ON_ITEM_ACTION(value){
                this.dialog_action_menu =! this.dialog_action_menu
            }
            

            //---------------[MAIN FUNCTIONS]------------   
             

        },
        beforeDestroy(){
            try {
                this.MBS.events.$off('ON_QR_SCAN', this.ON_QR_SCAN);  
                this.MBS.events.$off('MBS_KEYBOARD', this.MBS_KEYBOARD);      
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch:{  
            SELECTED_ITEMS(value){
                 
            },
            CompanySettings(value){
                if (value) {   
                    this.INITIALIZE_ITEMS_CATEGORIES()
                    this.INITIALIZE_ITEMS_DEPARTMENTS()
                }
            }, 
            selected_departments(value){
                this.ON_UPDATE_DEPARTMENT(value)
                if (value) {   
                    this.INITIALIZE_ITEMS_CATEGORIES() 
                }
            },  
        } 

    }
</script>
<style>
    .selected {
        background-color: #a8dadc;
    }
    .checked {
        background-color: #dadada;
    }
    
</style> 